const stats = [
  {
    icon: 'ri-shield-check-line',
    label: 'Sistemas Críticos',
    value: '100+',
    desc: 'Instalações realizadas com sucesso',
  },
  {
    icon: 'ri-tools-line',
    label: 'Anos de Experiência',
    value: '2+',
    desc: 'Em segurança eletrônica',
  },
  {
    icon: 'ri-building-2-line',
    label: 'Clientes Nacionais',
    value: '12+',
    desc: 'Empresas de renome atendidas',
  },
  {
    icon: 'ri-headphone-line',
    label: 'Suporte Técnico',
    value: '24/7',
    desc: 'Disponibilidade total garantida',
  },
];

const values = [
  { icon: 'ri-focus-3-line', label: 'Compromisso com o resultado' },
  { icon: 'ri-eye-line', label: 'Transparência total' },
  { icon: 'ri-medal-line', label: 'Excelência técnica' },
  { icon: 'ri-handshake-line', label: 'Ética nas relações' },
  { icon: 'ri-lightbulb-flash-line', label: 'Inovação constante' },
];

export default function About() {
  return (
    <section id="about" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left: Text Content */}
          <div>
            <span className="inline-block text-red-600 text-xs font-bold uppercase tracking-widest bg-red-50 px-3 py-1.5 rounded-full mb-6">
              / Sobre Nós
            </span>
            <h2 className="text-4xl lg:text-5xl font-bold text-neutral-900 mb-6 leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
              A RE_CONECTA<br />
              <span className="text-red-600">Tecnologia</span>
            </h2>
            <p className="text-neutral-600 text-base leading-relaxed mb-8">
              A RE_CONECTA Tecnologia nasceu para{' '}
              <strong className="text-neutral-900">simplificar o complexo</strong>. Com vasta experiência em
              implantação e manutenção de sistemas críticos de segurança e monitoramento, atendemos clientes
              de renome nacional com <strong className="text-neutral-900">agilidade e rigor técnico</strong>.
            </p>

            {/* Missão */}
            <div className="border-l-4 border-red-600 bg-red-50/60 rounded-r-xl px-5 py-4 mb-4">
              <p className="text-red-700 text-xs font-bold uppercase tracking-widest mb-1.5">Missão</p>
              <p className="text-neutral-700 text-sm leading-relaxed">
                Prover soluções de tecnologia e segurança eletrônica de alta precisão, garantindo a
                continuidade e a proteção das operações dos nossos clientes com{' '}
                <strong className="text-neutral-900">agilidade e rigor técnico</strong>.
              </p>
            </div>

            {/* Visão */}
            <div className="border-l-4 border-neutral-800 bg-neutral-50 rounded-r-xl px-5 py-4 mb-6">
              <p className="text-neutral-800 text-xs font-bold uppercase tracking-widest mb-1.5">Visão</p>
              <p className="text-neutral-700 text-sm leading-relaxed">
                Ser a referência em <strong className="text-neutral-900">inteligência tecnológica e sistemas críticos</strong> no
                Sul do Brasil, conectando inovação à segurança real.
              </p>
            </div>

            {/* Valores */}
            <div>
              <p className="text-neutral-500 text-xs font-bold uppercase tracking-widest mb-3">Nossos Valores</p>
              <div className="flex flex-wrap gap-2">
                {values.map((v) => (
                  <div key={v.label} className="flex items-center gap-2 bg-neutral-50 border border-neutral-200 rounded-full px-3.5 py-1.5 hover:border-red-300 hover:bg-red-50/40 transition-colors group">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className={`${v.icon} text-red-500 group-hover:text-red-600 text-sm transition-colors`}></i>
                    </div>
                    <span className="text-neutral-700 text-xs font-medium whitespace-nowrap">{v.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right: Stats Grid */}
          <div className="grid grid-cols-2 gap-5">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="bg-neutral-50 border border-neutral-100 rounded-2xl p-7 hover:border-red-200 hover:bg-red-50/20 transition-all group"
              >
                <div className="w-11 h-11 flex items-center justify-center bg-red-100 group-hover:bg-red-200 rounded-xl mb-4 transition-colors">
                  <i className={`${stat.icon} text-red-600 text-xl`}></i>
                </div>
                <p className="text-4xl font-bold text-neutral-900 mb-1" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  {stat.value}
                </p>
                <p className="text-neutral-800 font-semibold text-sm">{stat.label}</p>
                <p className="text-neutral-500 text-xs mt-1">{stat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
